<ng-container *ngIf="renderChildren | async as doRender; else loading">
  <div *ngIf="project">
    <mat-card class="top-card upper-space mat-elevation-z0">
      <div>
        <div class="form-title under-space">
          <div
            *ngIf="project.projectContacts?.length <= 1"
            class="form-title-text"
          >
            Bedrijf
          </div>
          <div
            *ngIf="project.projectContacts.length > 1"
            class="form-title-text"
          >
            Bedrijven
          </div>
        </div>
        <div
          [ngClass]="last ? '' : 'underline'"
          *ngFor="
            let pcg of projectContactGroups;
            let first = first;
            let last = last
          "
        >
          <div [ngClass]="first ? '' : 'upper-space'">
            <div *ngIf="pcg.contacts != null && pcg.contacts.length > 0">
              <div
                class="font-weight-bold"
                [ngClass]="client ? '' : 'click-link'"
                [routerLink]="client ? [] : ['/bedrijven', pcg.company.id]"
              >
                {{ pcg.company.regularName }}
              </div>
              <div *ngFor="let groupContact of pcg.contacts" class="d-flex">
                <div
                  [ngClass]="client ? '' : 'click-link'"
                  [routerLink]="client ? [] : ['/contacten', groupContact.id]"
                >
                  <span *ngIf="groupContact.firstName"
                    >{{ groupContact.firstName }}
                  </span>
                  <span *ngIf="groupContact.lastName">{{
                    groupContact.lastName
                  }}</span>
                </div>
                <div
                  *ngFor="
                    let phone of groupContact.telephones;
                    let first = first
                  "
                >
                  <span>&nbsp;/&nbsp;</span>
                  <a class="click-link" href="tel:{{ phone.number }}">
                    {{ phone.number | asFormatPhoneNumber }}
                  </a>
                </div>
                <div
                  *ngFor="let email of groupContact.emails; let first = first"
                >
                  <span>&nbsp;/&nbsp;</span>
                  <a
                    class="click-link"
                    href="{{
                      email.email
                        | mailSubjectBodyLink
                          : project.id
                          : groupContact.firstName
                          : inputProject.projectPlacement?.address?.line1
                          : inputProject.projectPlacement?.address?.postalCode
                          : inputProject.projectPlacement?.address?.city
                    }}"
                  >
                    {{ email.email }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="project.products?.length > 0">
        <div class="form-title upper-space">
          <div class="form-title-text">Producten</div>
        </div>
        <div
          *ngFor="let product of project.products; let index = index"
          style="width: 100%"
        >
          <product-summary-picker
            style="width: 100%;"
            [inputProduct]="product"
            [inputProject]="project"
            [inputSubProject]="inputProject"
            [index]="index"
            [client]="client"
          >
          </product-summary-picker>
        </div>
        <div *ngIf="client" class="upper-space">
          <product-price-summary [project]="project"></product-price-summary>
        </div>
      </div>

      <div class="upper-space">
        <div class="form-title">
          <div class="form-title-text">Algemene plaatsingsinfo</div>
        </div>
        <div class="d-flex justify-content-start">
          <div class="flexer right-space">
            <div *ngIf="inputProject.projectPlacement?.address">
              <span class="font-weight-bold">Adres: </span>
              <span
                class="address-text"
                *ngIf="
                  inputProject.projectPlacement.address.line1 ||
                  inputProject.projectPlacement.address.postalCode ||
                  inputProject.projectPlacement.address.city
                "
              >
                {{ inputProject.projectPlacement.address.line1 }},
                {{ inputProject.projectPlacement.address.postalCode }}
                {{ inputProject.projectPlacement.address.city }}
              </span>
              <span
                class="address-text"
                *ngIf="
                  !inputProject.projectPlacement.address.line1 &&
                  !inputProject.projectPlacement.address.postalCode &&
                  !inputProject.projectPlacement.address.city
                "
              >
                Er zijn geen adres gegevens ingevuld
              </span>
            </div>
            <div *ngIf="inputProject.projectPlacement?.extraInfoAddress">
              <span class="font-weight-bold">Extra info adres: </span>
              <span class="preserve-line-break">{{
                inputProject.projectPlacement.extraInfoAddress
              }}</span>
            </div>
            <div *ngIf="inputProject.projectPlacement?.kilometersTo">
              <span class="font-weight-bold">Enkele rit: </span>
              <span class=""
                >{{ inputProject.projectPlacement.kilometersTo }} Km</span
              >
            </div>
          </div>

          <div class="flexer">
            <div *ngIf="inputProject.projectPlacement?.extraInfoSite">
              <div class="font-weight-bold">Extra info locatie:</div>
              <span class="preserve-line-break">{{
                inputProject.projectPlacement.extraInfoSite
              }}</span>
            </div>
            <div
              [ngClass]="
                inputProject.projectPlacement?.extraInfoSite
                  ? 'small-upper-space'
                  : ''
              "
              *ngIf="inputProject.projectPlacement?.extraPlacementInfo"
            >
              <div class="font-weight-bold">Extra info plaatsing:</div>
              <span class="preserve-line-break">{{
                inputProject.projectPlacement.extraPlacementInfo
              }}</span>
            </div>
            <div *ngIf="inputProject.projectPlacement?.needAppointmentInfo">
              <span class="font-weight-bold">Afspraak nodig info: </span>
              <span class="preserve-line-break">{{
                inputProject.projectPlacement.needAppointmentInfo
              }}</span>
            </div>
            <div
              *ngIf="
                inputProject.projectPlacement?.appointment &&
                (inputProject.projectPlacement?.appointmentDate ||
                  inputProject.projectPlacement?.appointmentTime)
              "
            >
              <span class="font-weight-bold">Afspraak tijdstip: </span>
              <span>{{
                inputProject.projectPlacement.appointmentDate
                  | displayDateTime
                    : inputProject.projectPlacement.appointmentTime
              }}</span>
            </div>
            <div
              *ngIf="
                inputProject.projectPlacement?.appointment &&
                inputProject.projectPlacement?.collectKey &&
                collectKeyFromAddress != null
              "
            >
              <span class="font-weight-bold">Sleutel afhalen: </span>
              <span class="preserve-line-break">{{
                collectKeyFromAddress
              }}</span>
            </div>
          </div>
        </div>

        <div
          *ngIf="displayTotalExecutionTime && totalExecutionTime?.length > 0"
        >
          <span class="strong">Totale uitvoeringstijd: </span
          >{{ totalExecutionTime }}
        </div>

        <div
          *ngFor="let product of project.products; let index = index"
          style="width: 100%; margin-top: 10px;"
        >
          <product-placement-summary
            style="width: 100%"
            [inputProduct]="product"
            [inputProject]="project"
            [inputSubProject]="inputProject"
            [index]="index"
          >
          </product-placement-summary>
        </div>
      </div>
    </mat-card>

    <div *ngIf="!client">
      <invoice-preview
        *ngIf="inputProject.id"
        [project]="project"
        [inputProject]="inputProject"
        [productAdded]="productAdded"
        [boardPartAdded]="boardPartAdded"
      >
      </invoice-preview>

      <placement-invoice
        *ngIf="
          inputProject.type === 'BaseProject' &&
          inputProject.projectInvoices != null &&
          project.products?.length > 0
        "
        [project]="project"
        [inputProject]="this.inputProject"
        [involvedCompanies]="involvedCompanies"
        [updateEmitter]="outputProject"
        [productAdded]="productAdded"
        [boardPartAdded]="boardPartAdded"
        [standardStickerPartAdded]="standardStickerPartAdded"
        [standardStickerPartDeleted]="standardStickerPartDeleted"
        [invoiceSent]="invoiceSent"
      ></placement-invoice>
    </div>
  </div>
</ng-container>
<ng-template #loading>
  <mat-spinner
    style="align-self: center; margin: auto;"
    color="primary"
    diameter="48"
  ></mat-spinner>
</ng-template>
